import SignalRApiService from './SignalRApiService'
import UserApiService from './UserApiService'
import InvoicesApiService from './InvoicesApiService'
import ClientApiService from './ClientApiService'
import CandidateApiService from './CandidateApiService'
import FileApiService from './FileApiService'
import TimesheetsApiService from './TimesheetsApiService'
import ContactsApiService from './ContactsApiService'
import LocationsApiService from './LocationsApiService'
import BookingsApiService from './BookingsApiService'
import PendingFeedbackApiServiceApiService from './PendingFeedbackApiServiceApiService'

export default {
  pendingfeedbacks: new PendingFeedbackApiServiceApiService(),
  bookings: new BookingsApiService(),
  locations: new LocationsApiService(),
  contacts: new ContactsApiService(),
  timesheets: new TimesheetsApiService(),
  file: new FileApiService(),
  invoices: new InvoicesApiService(),
  client: new ClientApiService(),
  candidate: new CandidateApiService(),
  user: new UserApiService(),
  signalR: new SignalRApiService(),
}
